import React, { createContext, FC, memo } from "react";
import { useSelector } from "react-redux";

import { getSelectedTabId } from "../../../ducks/project/selectors";
import { useProjectDataSourceFilters } from "../../FeatureCard/hooks/useProjectDataSourceFilters";
import { useAction } from "../../../hooks/useAction";
import { useExpandableContainers } from "../../FeatureCard/hooks/useExpandableContainers";
import {
  nextPage as nextPageAction,
  prevPage as prevPageAction,
  setSelectedTabId as setSelectedTabIdAction,
  changePage as changePageAction,
} from "../../../ducks/project/project";
import { DashboardContextProps } from "../types";

export const DashboardContext = createContext<DashboardContextProps>(null);

export const DashboardProvider: FC = memo(({ children }) => {
  const [filters, changeFilters] = useProjectDataSourceFilters();
  const selectedTabId = useSelector(getSelectedTabId);
  const setSelectedTabId = useAction(setSelectedTabIdAction);
  const [expandedContainers, expandContainer] = useExpandableContainers();
  const nextPage = useAction(nextPageAction);
  const prevPage = useAction(prevPageAction);
  const changePage = useAction(changePageAction);

  return (
    <DashboardContext.Provider
      value={{
        expandedContainers,
        expandContainer,
        filters,
        changeFilters,
        selectedTabId,
        setSelectedTabId,
        nextPage,
        prevPage,
        changePage,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
});
